import * as ContextMenu from "@radix-ui/react-context-menu";
import React from "react";

/**
 * Do not import from here. Import from ContextMenu.tsx
 */
export const ContextMenuSeparator = () => {
  return <ContextMenu.Separator className="my-1 h-px bg-gray-100" />;
};
